// extracted by mini-css-extract-plugin
export default {"container":"Gh","overlay":"Hh","videoOverlay":"Ih","withHeader":"Jh","header":"Kh","close":"Lh","content":"Mh"};